import Template from 'backbone/platform/templates/assets/assets_filters.js.hamlc'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class AssetsFiltersView extends Backbone.View
  events:
    "change select"           : "changeFilters"
    "click .reset-filters"    : "resetFilters"
    "click .js-clear-search"  : "clearSearchBar"
    "keyup .asset-search"     : "typingSearchBar"

  initialize: (options) ->
    @dispatcher = BackboneDispatcher.get_instance()
    @collection = options.collection

  render: =>
    @$el.html Template
      collection: @collection
    contently.ui.setup_select2(@$el)
    if @collection.query
      @$("#query").val(@collection.query).focus()
      @$(".js-clear-search").removeClass "hidden"

  changeFilters: (event) ->
    @$(".reset-filters").removeClass("hidden") if event.target.tagName == "SELECT"

    _.each @$("select"), (filter) =>
      $filter = $(filter)
      @collection.setFilter($filter.attr('name'), $filter.val())

    searchQuery = @$el.find("#query").val()
    @collection.setQuery(searchQuery)

    @collection.fetch()

  resetFilters: ->
    @collection.resetFilters()
    @collection.fetch
      success: =>
        @render()
    this

  clearSearchBar: (e) ->
    @$("#query").val("")
    @changeFilters(e)
    @$(".js-clear-search").addClass "hidden"

  typingSearchBar: (e) ->
    if e.which == 13
      @dispatcher.trigger("searchAssets", e)
    else if e.target.value
      @$(".js-clear-search").removeClass "hidden"
    else
      @$(".js-clear-search").addClass "hidden"



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/assets_filters_view.js.coffee